import Property from '../../lib/structure/Property'

export const PANEL_WIDTH = 258
export const LEFT_SIDE_SPACE = 108

export const EXPANSION_DURATION = 300

export const INITIALLY_COLLAPSED_GROUPS = [
  'size',
  'fill',
  'stroke',
  'shadow',
  'points',
]

export const PAIRED_VECTOR_TYPES = [
  'scale',
]

export const NO_DRAG_BOX_TYPES = [
  Property.PRIMITIVES.STRING,
  Property.PRIMITIVES.BOOLEAN,
]
